import { render, staticRenderFns } from "./RequestTypeSelector.vue?vue&type=template&id=06fccdd5&scoped=true"
import script from "./RequestTypeSelector.vue?vue&type=script&lang=js"
export * from "./RequestTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./RequestTypeSelector.vue?vue&type=style&index=0&id=06fccdd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fccdd5",
  null
  
)

export default component.exports